<div class="header d-flex justify-content-between align-items-center w-100">
  <div class="d-flex gap-5 align-items-center">
    <img src="assets/logos/logo-black.png" class="logo" alt="logo" />
    <div class="d-flex gap-4 align-items-center">
      @for (item of navList; track item.id) {
      <div
        class="d-flex align-items-center gap-1 nav-item"
        [routerLink]="item.route"
        [ngClass]="item.id == routerSelected ? 'selected' : ''"
        (click)="handleClickNav(item)"
      >
        <svg-icon
          class="icon"
          [src]="
            'assets/icons/' +
            item.icon +
            (item.id == routerSelected ? '-blue' : '-grey') +
            '.svg'
          "
        ></svg-icon>
        <div class="label">{{ item.label }}</div>
      </div>
      }
    </div>
  </div>
  <div class="d-flex align-items-center gap-2">
    <div class="position-relative">
      <div class="badge" *ngIf="notifNotReaded">
        {{ notifNotReaded > 99 ? "+99" : notifNotReaded }}
      </div>
      <svg-icon
        (click)="notifNotReaded = 0"
        [matMenuTriggerFor]="notif"
        class="notification"
        src="assets/icons/notif.svg"
      ></svg-icon>
      <mat-menu #notif="matMenu" class="notification-container">
        <app-notification-panel
          [notifications]="notification"
          (itemClick)="notifClicked($event)"
        ></app-notification-panel>
      </mat-menu>
    </div>
    <div>
      <div
        [matMenuTriggerFor]="user"
        class="profile-menu d-flex align-items-center gap-2"
      >
        <img
          *ngIf="condidat?.photo"
          [src]="'data:image/jpeg;base64,' + condidat?.photo"
          class="user-img"
          alt="user"
        />
        <svg-icon
          [svgStyle]="{ 'width.px': 38, 'height.px': 38 }"
          *ngIf="!condidat?.photo"
          src="/assets/icons/no-pic.svg"
        ></svg-icon>
        <div>
          <div class="name">
            {{ condidat?.civility ? condidat?.civility + "." : "" }}
            {{
              condidat?.fullname ||
                condidat?.firstname + " " + condidat?.lastname
            }}
          </div>
          <div class="email">{{ condidat?.mailadress }}</div>
        </div>
        <svg-icon src="assets/icons/chevron-down.svg"></svg-icon>
      </div>
      <mat-menu #user="matMenu">
        <button mat-menu-item class="" routerLink="/profile">
          <svg-icon src="assets/icons/profile.svg"></svg-icon>
          Mon profil et mes filtres permanents
        </button>
        <!-- <button mat-menu-item class="" routerLink="/accueil">
          <svg-icon src="assets/icons/profile.svg"></svg-icon>
          Les offres de missions disponibles
        </button>
        <button mat-menu-item class="" routerLink="/profile">
          <svg-icon src="assets/icons/profile.svg"></svg-icon>
          Mes notifications
        </button>
        <button mat-menu-item class="" routerLink="/profile">
          <svg-icon src="assets/icons/profile.svg"></svg-icon>
          Tableaux de bord de mes missions
        </button>
        <button mat-menu-item class="" routerLink="/profile">
          <svg-icon src="assets/icons/profile.svg"></svg-icon>
          Nouvelle recherche de missions
        </button>
        <button mat-menu-item class="" routerLink="/profile">
          <svg-icon src="assets/icons/profile.svg"></svg-icon>
          Aide
        </button>
        <button mat-menu-item class="" routerLink="/profile">
          <svg-icon src="assets/icons/profile.svg"></svg-icon>
          Contact
        </button>
        <button mat-menu-item class="" routerLink="/profile">
          <svg-icon src="assets/icons/profile.svg"></svg-icon>
          Politique de confidentialité
        </button> -->
        <button mat-menu-item (click)="disconnect()">
          <svg-icon src="assets/icons/disconnect.svg"></svg-icon>
          Se déconnecter
        </button>
      </mat-menu>
    </div>
  </div>
</div>
